var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('base-table',_vm._g(_vm._b({attrs:{"columns":_vm.columns},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function($scopedSlot,name){return {key:name,fn:function({row}){return [_vm._t(name,null,{"row":row})]}}})],null,true)},'base-table',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }